export default "__VITE_ASSET__FBrJq2H4__"